import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-20 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
            关于91浏览器的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer transition-colors hover:bg-background-100/50"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                  openIndex === index ? 'bg-primary-100 rotate-180' : 'bg-background-200'
                }`}>
                  <i className={`text-xs transition-colors ${
                    openIndex === index ? 'ri-subtract-line text-primary-600' : 'ri-add-line text-foreground-500'
                  }`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 md:px-6 pb-5 md:pb-6 text-sm text-foreground-500 leading-relaxed border-t border-background-200/50 pt-4">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}